import list from './list'
import edit from './edit'
import create from './create'
import icon from '@material-ui/icons/Person'

const nationalities = { list, icon, options: { label: 'Nationalities' } }

export default nationalities
